import { useAtom } from 'jotai'

import { filtersAtom } from 'atoms/filters.atom'
import { SearchBar } from 'components/searchBar/SearchBar'
import { ListItem } from 'components/uikit/ListItem'
import { MultiSelect } from 'components/uikit/MultiSelect'
import { SingleSelect } from 'components/uikit/SingleSelect'
import { AllCategories, ous } from 'constants/awards.constants'
import { AnalyticsActionType } from 'types/analytics.type'
import { ANALYTICS_EVENTS, trackAnalytics } from 'utils/analytics'

export interface FiltersProps {
  search?: string
  ou?: string
  year?: string
  entry?: 'all' | 'shortlist' | 'winner' | 'braveBoundless'
}

const years = ['2023', '2024', '2025']

export const FiltersIndex = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filters, setFilters] = useAtom(filtersAtom)

  const handleSearchChange = (searchValue: string) => {
    setFilters({ ...filters, search: searchValue })
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: {
        action: ANALYTICS_EVENTS.ACTION.SEARCHBAR_SEARCH,
        params: [
          {
            key: 'searchValue',
            value: searchValue,
          },
        ],
      },
    })
  }

  const handleOuChange = (value: string[]) => {
    setFilters({ ...filters, ou: value })
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: ANALYTICS_EVENTS.ACTION.OU_SELECT,
    })
  }

  const handleYearChange = (value: string[]) => {
    setFilters({ ...filters, year: value })
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: ANALYTICS_EVENTS.ACTION.YEAR_SELECT,
    })
  }

  const handleCategoryChange = (value: string[]) => {
    setFilters({ ...filters, category: value })
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: ANALYTICS_EVENTS.ACTION.CATEGORY_SELECT,
    })
  }

  const handleEntryChange = (value: 'all' | 'shortlist' | 'winner' | 'braveBoundless') => {
    setFilters({ ...filters, entry: value })
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: ANALYTICS_EVENTS.ACTION.SUBMISSION_SELECT,
    })
  }

  return (
    <div className="flex gap-[10px] font-TCCC my-[48px]">
      <SearchBar
        className="text-black w-[205px]"
        onDebouncedSearch={(searchval: string) => {
          handleSearchChange(searchval)
        }}
        placeholder="Search..."
      />
      <MultiSelect
        value={filters.category}
        placeholder="Select Category"
        className="text-black w-[192px] font-TCCC"
        onChange={event => {
          handleCategoryChange(event.detail.value)
        }}
      >
        {AllCategories.map(category => (
          <ListItem key={category} value={category}>
            <p slot="label" className="font-TCCC">
              {category === '' ? null : category}
            </p>
          </ListItem>
        ))}
      </MultiSelect>
      <MultiSelect
        // dropdownPosition="absolute"
        // dropdownConfig={{
        //   placement: 'bottom-start',
        // }}
        placeholder="Select OUs"
        className="text-black w-[192px] font-TCCC"
        value={filters.ou}
        onChange={event => {
          handleOuChange(event.detail.value)
        }}
      >
        {ous.map(ou => (
          <ListItem key={ou} value={ou} className="font-TCCC">
            <p slot="label" className="font-TCCC">
              {ou}
            </p>
          </ListItem>
        ))}
      </MultiSelect>
      <MultiSelect
        // dropdownPosition="absolute"
        // dropdownConfig={{
        //   placement: 'bottom-start',
        // }}
        placeholder="Select Year"
        className="text-black w-[192px] font-TCCC"
        value={filters.year}
        onChange={event => {
          handleYearChange(event.detail.value)
        }}
      >
        {years.map(year => (
          <ListItem key={year} value={year} className="font-TCCC">
            <p slot="label" className="font-TCCC">
              {year}
            </p>
          </ListItem>
        ))}
      </MultiSelect>
      <SingleSelect
        // dropdownPosition="absolute"
        // dropdownConfig={{
        //   placement: 'bottom-start',
        // }}
        placeholder="Select OUs"
        className=" font-normal w-[192px] font-TCCC"
        value={filters.entry}
        onChange={event => {
          handleEntryChange(event.detail.value)
        }}
      >
        <ListItem key="all" value="all" className="font-TCCC font-normal">
          <p slot="label" className="font-TCCC font-normal">
            All Submissions
          </p>
        </ListItem>
        <ListItem key="shortlist" value="shortlist" className="font-TCCC">
          <p slot="label" className="font-TCCC font-normal">
            Shortlist
          </p>
        </ListItem>
        <ListItem key="winner" value="winner" className="font-TCCC">
          <p slot="label" className="font-TCCC font-normal">
            Winner
          </p>
        </ListItem>
        <ListItem key="braveBoundless" value="braveBoundless" className="font-TCCC">
          <p slot="label" className="font-TCCC font-normal">
            B&B Winner
          </p>
        </ListItem>
      </SingleSelect>
    </div>
  )
}
